import { render, staticRenderFns } from "./ProfilePost.vue?vue&type=template&id=99065154&"
import script from "./ProfilePost.vue?vue&type=script&lang=js&"
export * from "./ProfilePost.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePost.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports